// extracted by mini-css-extract-plugin
module.exports = {"addressMinified":"address-minified_addressMinified__Sm4OI"};